import React from 'react'
import {Autocomplete, Button, css, Select} from '@bdfx/mergado-ui-kit'
import {godProjectId} from "../helpers/api"
import {GOD_MODE_COOKIE} from "../config/api-config"
import Cookies from "universal-cookie"
import {getFakeProjectId} from "../helpers/url-params";

interface Props {
    godAllProjects: any,
}

interface State {
    autocomplete: string
}

export class AutocompleteGodProjects extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            autocomplete: godProjectId || '',
        };
    }

    shouldItemRender = (item, value) => {
        return (
            item.value.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
            item.text.toLowerCase().indexOf(value.toLowerCase()) > -1
        );
    }

    resetFakeProjectId = () => {
        if(confirm('Opravdu chcete resetovat project_id?')) {
            const cookies = new Cookies()
            cookies.remove(GOD_MODE_COOKIE, { path: "/", sameSite: "none", secure: true })
            window.location.reload()
            this.setState({ autocomplete: null })
        }
    }

    setFakeProjectId = (fid) => {
        if(fid === "") {
            this.resetFakeProjectId()
        } else
        if(confirm('Opravdu chcete nastavit project_id na ' + fid + '?')) {
            const cookies = new Cookies()
            cookies.set(GOD_MODE_COOKIE, fid, { path: '/', sameSite: 'none', secure: true });
            window.location.reload()
        }
    }

    public render() {
        const { godAllProjects } = this.props;

        return (
            <AutocompleteStyled>
                <Autocomplete
                    placeholder={'project'}
                    items={godAllProjects.map((o) => {
                        return {
                            value: `${o.value}: ${o.text}`,
                            text: `${o.value}: ${o.text}`,
                        }
                    })}
                    onClear={this.resetFakeProjectId}
                    onChange={(e) => {
                        this.setState({ autocomplete: e })
                        const arr = e.split(':')
                        const projectId = arr[0] ?? null
                        if (projectId) {
                            const fid = godAllProjects.find((o) => `${o.value}` === `${projectId}`)
                            if (fid && fid.value) {
                                this.setFakeProjectId(fid.value)
                            }
                        }
                    }}
                    search={true}
                    value={`${this.state.autocomplete}`}
                /> 
            </AutocompleteStyled>
        );
    }
}

const AutocompleteStyled = css("div")({
    background: "rgb(234, 78, 75)",
    display: "inline-block",
    borderRadius: "5px",
    zIndex: 10,
    padding: "5px",
    "& .muk-form-group": {
        marginBottom: 0,
        display: "inline-block",
        background: "white",
        width: "200px",
    },

    "& .muk-input-text": {
        width: "140px",
    },

    "& .muk-button__item ": {
        padding: "5px",
    },
    'li': {
        fontSize: 'small !important',
        height: 'auto !important',
    },
})

export default AutocompleteGodProjects;
